import { render, staticRenderFns } from "./Aaccount.vue?vue&type=template&id=2ece8394"
import script from "./Aaccount.vue?vue&type=script&lang=js"
export * from "./Aaccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports